var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4024 2C12.9113 2.1196 13.442 2.1794 13.9181 2.3751C15.7238 3.11443 16.8237 4.45719 17.163 6.37619C17.5351 8.5072 16.4844 10.6817 14.5364 11.72C12.6431 12.7312 10.7608 12.6279 8.99336 11.4047C7.57613 10.4262 6.83195 9.02364 6.79912 7.31122C6.76081 5.40853 7.59255 3.90813 9.17941 2.84262C9.87982 2.36967 10.6623 2.11416 11.505 2.02718C11.5433 2.02175 11.5816 2.01087 11.6199 2C11.8771 2 12.1397 2 12.4024 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 21.9999C9.6936 21.9782 7.61426 21.315 5.78664 19.9613C4.71414 19.1622 3.81127 18.1945 3.11086 17.0475C3.00689 16.8735 2.95765 16.705 3.0452 16.5147C3.95901 14.6012 5.44191 13.3835 7.5103 12.8724C7.65804 12.8344 7.80578 12.8181 7.95352 12.7855C8.27637 12.7148 8.55544 12.8072 8.81809 12.992C9.85229 13.7151 11.0014 14.0358 12.2599 13.9814C13.223 13.9434 14.1478 13.7151 14.9193 13.1497C15.5103 12.7148 16.0793 12.7474 16.7141 12.9214C18.4487 13.4052 19.7565 14.4381 20.6867 15.9602C21.0971 16.6343 21.1135 16.6561 20.6812 17.303C19.6361 18.8686 18.2736 20.0918 16.5718 20.929C15.1327 21.6466 13.5951 21.989 11.959 21.9999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.8a35115e.svg";
export { ForwardRef as ReactComponent };